import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { IComboBox } from "@interfaces/IComboBox";
import "./close-route-reason.component.scss";
import { PlannedRouteClosureReason } from "../../_enums/PlannedRouteClosureReason";

@Component({
    selector: "close-route-reasons",
    template: require("./close-route-reason.component.html")
})
export class CloseRouteReasonComponent implements OnInit {

    @Input()  plannedRouteClosureReason: PlannedRouteClosureReason = null;
    @Output() optionChanged = new EventEmitter<PlannedRouteClosureReason>(); // Create an EventEmitter
    closureReasonOptions: IComboBox[] = [];

    ngOnInit(): void {
        for (const key in PlannedRouteClosureReason) {
            if (isNaN(Number(key))) {
                this.closureReasonOptions.push({ Name: key, Value: '' });
            }
        }
    }

    emitPlannedRouteClosureReason(value) {
     this.plannedRouteClosureReason = value;
     this.optionChanged.emit(this.plannedRouteClosureReason);
    }
}
